const EchoTable = () => {
  return (
    <table className="w-full border-collapse border border-gray-300 mt-2">
      <thead>
        <tr>
          <th className="border border-gray-300 p-2 text-left bg-gray-100 print:bg-white text-xs">Parameters</th>
          <th className="border border-gray-300 p-2 text-left bg-gray-100 print:bg-white text-xs">Measurement</th>
          <th className="border border-gray-300 p-2 text-left bg-gray-100 print:bg-white text-xs">Parameters</th>
          <th className="border border-gray-300 p-2 text-left bg-gray-100 print:bg-white text-xs">Measurement</th>
        </tr>
      </thead>
      <tbody>
        {[
          ["IVSd", "EDV"],
          ["IVSs", "ESV"],
          ["LVIDd", "SV"],
          ["LVIDs", "EF"],
          ["LVPWd", "FS"],
          ["LVPWs", ""],
        ].map(([leftParam, rightParam], index) => (
          <tr key={index}>
            <td className="border border-gray-300 p-2 bg-gray-100 print:bg-white italic">
              <input
                type="text"
                className="w-full bg-transparent border-none focus:outline-none text-xs"
                defaultValue={leftParam}
              />
            </td>
            <td className="border border-gray-300 p-2 bg-gray-100 print:bg-white italic">
              <input type="text" className="w-full bg-transparent border-none focus:outline-none text-xs" />
            </td>
            <td className="border border-gray-300 p-2 bg-gray-100 print:bg-white italic">
              <input
                type="text"
                className="w-full bg-transparent border-none focus:outline-none text-xs"
                defaultValue={rightParam}
              />
            </td>
            <td className="border border-gray-300 p-2 bg-gray-100 print:bg-white italic">
              <input type="text" className="w-full bg-transparent border-none focus:outline-none text-xs" />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default EchoTable;
